import React, { useCallback, useState } from "react";

export default function useDeleteDialog(initialState) {
  const [isOpen, setIsOpen] = useState(initialState);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  return { isOpen, close, open };
}
